import { render, staticRenderFns } from "./LedgerNav.vue?vue&type=template&id=547132de&scoped=true&"
import script from "./LedgerNav.vue?vue&type=script&lang=js&"
export * from "./LedgerNav.vue?vue&type=script&lang=js&"
import style0 from "./LedgerNav.vue?vue&type=style&index=0&id=547132de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547132de",
  null
  
)

export default component.exports